import React from 'react';
import { useEffect, useState } from 'react';
import { useSendIdleNotification } from 'shared-state/notifications/hooks';
import './style.css';
import useBrowserNotificationData from './useBrowserNotificationData';
import IvicosStrings from 'kits/language/stringKit';
import { IDLE_NOTIFICATION_AUTO_CLOSE_MS } from 'shared-state/identity/constants/activityTimerConstants';

export const WebBrowserNotification: React.FC<{}> = () => {
    const { openNotificationSettings, permission, isNotificationSupported } = useBrowserNotificationData();
    const [notificationBlocked, setNotificationBlocked] = useState(false);
    const [sendIdleNotification, setSendIdleNotification] = useSendIdleNotification();

    useEffect(() => {
        if (!isNotificationSupported) return;
        const handlePermissionCheck = () => {
            if (permission === 'denied') {
                setNotificationBlocked(true);
            }

            if (permission === 'denied' || permission === 'default') {
                setTimeout(openNotificationSettings, 1000);
            }
        };

        if (document.readyState === 'complete') {
            handlePermissionCheck();
        } else {
            window.addEventListener('load', handlePermissionCheck);
            return () => window.removeEventListener('load', handlePermissionCheck);
        }
    }, [permission, isNotificationSupported]);

    const sendNotification = () => {
        if (!isNotificationSupported || permission !== 'granted') return;
        const notification = new Notification(IvicosStrings.notificationMessageTitle, {
            body: IvicosStrings.notificationMessageBody,
            icon: `${process.env.PUBLIC_URL}/favicons/favicon-32x32.png`
        });

        notification.onclick = () => {
            window.focus();
            notification.close();
        };

        const autoCloseTimer = setTimeout(() => notification.close(), IDLE_NOTIFICATION_AUTO_CLOSE_MS);
        notification.onclose = () => clearTimeout(autoCloseTimer);

        // Play a custom sound
        const soundFilePath = `${process.env.PUBLIC_URL}/sounds/Bell.mp3`;
        const audio = new Audio(soundFilePath);
        audio.play();
    };

    useEffect(() => {
        if (isNotificationSupported && sendIdleNotification && !notificationBlocked && permission === 'granted') {
            sendNotification();
            setSendIdleNotification(false);
        }
    }, [sendIdleNotification, isNotificationSupported, notificationBlocked, permission]);

    return <></>;
};
